import { toCsv, type CsvCell } from '../../core/rules/csv'
import { attentionLabel, customerName, shapeLabel } from './customerRules'
import type { CustomerSummary } from '../../core/types/adminRequests'

/**
 * De klantenlijst als CSV (BEHEER-PLAN §3.6). Alleen wat ook in de lijst staat: geen notities,
 * huidplan, foto's of betaalgegevens. Puur en getest; de server levert de rijen pas na een recente
 * login (423 `reauth_required`) en legt vast wie wanneer exporteerde.
 */

export const CUSTOMER_EXPORT_HEADER = [
  'Naam',
  'E-mail',
  'Plaats',
  'Klant sinds',
  'Soort',
  'Abonnement',
  'Volgende afspraak',
  'Laatst geweest',
  'Laatst besteld',
  'Kuur',
  'Vraagt aandacht',
] as const

/** `treatmentName` zet een slug om in de naam van de behandeling (onbekend = de slug). */
export function customerCsv(rows: readonly CustomerSummary[], treatmentName: (slug: string) => string | undefined = () => undefined): string {
  const name = (slug: string) => treatmentName(slug) ?? slug
  const body = rows.map((c): CsvCell[] => [
    customerName(c),
    c.email || null,
    c.city || null,
    c.memberSince || null,
    shapeLabel(c.shape) || null,
    c.subscription ?? null,
    c.nextAppointment ? `${c.nextAppointment.date} ${c.nextAppointment.time} ${name(c.nextAppointment.treatmentSlug)}` : null,
    c.lastVisit,
    c.lastOrder,
    c.course ? `${name(c.course.treatmentSlug)} ${c.course.done}/${c.course.total}${c.course.prepaid ? ` vooruit betaald tot ${c.course.prepaid.validUntil}` : ''}` : null,
    c.attention.map((f) => attentionLabel[f]).join(', ') || null,
  ])
  return toCsv(CUSTOMER_EXPORT_HEADER, body)
}

/** "klanten-2026-10-08.csv", of met het filter erin: "klanten-lopende-kuur-2026-10-08.csv". */
export const customerExportFileName = (day: string, filterLabel?: string) =>
  `klanten-${filterLabel ? `${filterLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}-` : ''}${day}.csv`
